import { useState } from "react";
import { joinWaitlist } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, Loader2, Check } from "lucide-react";

export default function WaitlistForm({ compact = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const data = await joinWaitlist({ email });
      setResult(data);
      toast.success(data.message);
    } catch (err) {
      const msg =
        err?.response?.data?.detail?.[0]?.msg ||
        err?.response?.data?.detail ||
        "Something went wrong. Please try again.";
      toast.error(typeof msg === "string" ? msg : "Invalid email address");
    } finally {
      setLoading(false);
    }
  };

  if (result) {
    return (
      <div
        data-testid="waitlist-success"
        className="rounded-2xl border border-[#5FA836]/40 bg-[#5FA836]/8 p-5 max-w-xl"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="h-9 w-9 rounded-full bg-[#5FA836] grid place-items-center">
            <Check className="w-5 h-5 text-white" strokeWidth={3} />
          </div>
          <div className="font-display text-xl font-bold text-[#24303F]">
            You're #{result.position} on the list
          </div>
        </div>
        <p className="text-gray-700 font-body text-sm">{result.message}</p>
        {result.cashback_eligible && (
          <p className="mt-2 text-[#5FA836] font-display text-sm font-bold uppercase tracking-wider">
            ₹100 cashback locked in · {result.slots_remaining} slots left
          </p>
        )}
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="waitlist-form"
      className={`${compact ? "max-w-md" : "max-w-xl"} w-full`}
    >
      <div className="flex flex-col sm:flex-row items-stretch gap-3 rounded-2xl border border-[#e5e7eb] bg-white p-2 focus-within:border-[#5FA836]/60 transition-colors shadow-[0_2px_10px_-4px_rgba(36,48,63,0.08)]">
        <input
          data-testid="waitlist-email-input"
          type="email"
          required
          placeholder="you@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="flex-1 bg-transparent px-4 py-3 font-body text-base outline-none text-[#24303F] placeholder:text-gray-400"
        />
        <button
          data-testid="waitlist-submit-btn"
          type="submit"
          disabled={loading}
          className="btn-primary rounded-xl px-5 py-3 inline-flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <>
              Join Waitlist
              <ArrowRight className="w-4 h-4" />
            </>
          )}
        </button>
      </div>
      <p className="mt-3 font-body text-xs text-gray-500">
        First 100 users get <span className="text-[#5FA836] font-semibold">₹100 cashback</span> on first ride. No spam, unsubscribe anytime.
      </p>
    </form>
  );
}
